import Super from 'client-portal/routes/-request/prescreener-client-preferences';

export default class WidgetPrescreenerClientPreferences extends Super {}
